import { FormControlLabel, styled } from '@mui/material';

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin-right: 0;

  .MuiSwitch-root {
    margin-bottom: 0;
  }
`;
